module.exports = "/_next/static/images/cover-291eef10c313b7d7bbcfe2646d20d6fb.jpg";